<template>
  <div :class="ufClass" v-if="isAvailableShow">
    <InputSelect
      label="UF:"
      name="uf"
      v-model="uf"
      @change="carregarMunicipios"
      placeholder="Selecione uma das opções"
      :required="required"
      :options="stateList"
      :disabled="disabled"
    />
  </div>
  <div :class="municipioClass" v-if="isAvailableShow">
    <InputSelect
      label="Município:"
      name="municipio_id"
      v-model="municipio"
      @change="onChange"
      placeholder="Selecione uma das opções"
      :required="required"
      :options="municipios"
      :disabled="disabled"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import { stateList } from "@/core/listas/stateList";
import InputSelect from "@/components/Inputs/InputSelect/InputSelect.vue";
import { useUsuarioStore } from "@/store/usuarioStore";

export default defineComponent({
  name: "MunicipiosUf",
  components: { InputSelect },
  props: {
    modelValue: {
      type: [String, Number],
      required: false,
      default: "",
    },
    isAvailableShow: {
      type: Boolean,
      default: true,
    },
    municipioClass: {
      type: String,
      default: "col-sm-4",
    },
    ufClass: {
      type: String,
      default: "col-sm-2",
    },
    currentUf: {
      type: String,
      default: "",
    },
    currentMunicipio: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      municipios: [],
      uf: this.currentUf || "",
      municipio: this.currentMunicipio || "",
    };
  },
  computed: {
    stateList() {
      const usuarioStore = useUsuarioStore();
      const ufsPermitidas = usuarioStore.perfilDados?.uf;
      if (ufsPermitidas && ufsPermitidas.length > 0) {
        return stateList.filter((state) => ufsPermitidas.includes(state.value));
      }
      return stateList;
    },
  },
  methods: {
    async carregarMunicipios(event) {
      const usuarioStore = useUsuarioStore();
      const uf = event?.target?.value || event;
      if (!uf) return;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_ADMIN_API}/municipio/listagem/${uf}`
        );
        let municipiosList = response.data.dados.map((dado) => ({
          value: dado.id,
          label: dado.nome,
        }));

        // Seleciona automaticamente o município do perfil
        const perfilMunicipioId = usuarioStore.perfilDados?.municipioId;
        if (perfilMunicipioId) {
          const match = municipiosList.find(
            (m) => m.value === perfilMunicipioId
          );
          if (match) {
            this.municipio = perfilMunicipioId;
            this.$emit("update:modelValue", this.municipio);
          }
        }

        this.municipios = municipiosList;
      } catch {
        this.municipios = [];
      }
    },
    onChange() {
      return this.$emit("update:modelValue", this.municipio);
    },
  },
  watch: {
    currentUf(value) {
      if (value) {
        this.uf = value;
        this.carregarMunicipios(value);
      }
    },
    modelValue(modelValue) {
      this.municipio = modelValue;
    },
    isAvailableShow(value) {
      if (!value) {
        this.municipio = "";
        this.uf = "";
      }
    },
  },
  mounted() {
    const listaUFs = this.stateList;

    if (listaUFs.length === 1) {
      this.uf = listaUFs[0].value;
      this.carregarMunicipios(this.uf);
    } else if (this.currentUf) {
      this.uf = this.currentUf;
      this.carregarMunicipios(this.uf);
    }
  },
});
</script>
